/** @module csi/skintheme/SeaBreeze */
define([], function() {
	return {
		Blue1: "Cyan30",
		Blue2: "Cyan50",
		Blue3: "Cyan400",

		PrimaryBlue: "Cyan700",
		PrimaryDisabledColor: "Cyan200",
		PrimaryColor2: "Cyan800",
		PrimaryColor3: "Cyan900",

		SiteHeaderBackground: "Grey50",

		CompanyHeaderBlue1: "Grey50",
		CompanyHeaderBlue2: "Grey200",

		/* LINK */
		LinkNormal: "Blue600",
		LinkHover: "Blue800",
		LinkActive: "Blue600",

		/* Comment */
		CommentActiveColor: "Blue600",

		/** custom view */
		CustomViewOptionActiveColor: "Cyan500",

		/* FULL SCREEN HEADER */
		FullScreenHeaderBackgroundColor: "Grey50",
		FullScreenLogoBackgroundColor: "Grey50",

		/* TEXT */
		TabsTextActive: "Cyan700",

		/* Button */
		BtnPrimaryFocusedBorderColor: "Cyan900",
		ButtonSwitchNormalIconStateOnBackgroundColor: "Cyan700",

		/* BreadCrumb */
		BreadcrumbNormalLinkColor: "Blue600",

		/* CheckBox */
		CheckBoxFocusColor: "Cyan300",

		/* Text Border */
		TextfieldActiveBorderColor: "PrimaryColor",
		BtnToolbarFocusedBorderColor: "PrimaryColor",

		/* DropDown */
		DropdownSelectActiveBorderColor: "PrimaryColor",

		/* Header */
		LastVisitedIconColor: "Grey50",
		LastVisitedBackgroundColor: "Black400",
		PageHeaderButtonTextColor: "SecondaryText",
		PageHeaderToolbarIconColor: "Black400",
		PageHeaderToolbarHoverColor: "Cyan700",
		PageHeaderSearchInButtonHoverColor: "Grey100",
		PageHeaderToolbarSeparatorColor: "Grey300",
		PageHeaderSearchScopeBackgroundColor: "White50",
		PageHeaderSearchBlockBackgroundColor: "Grey300",
		CompanyLogoTextColor: "Black50",
		CompanyLogoImageURL: "LightCompanyLogoIconURL",
		ExitFullScreenIconURL: "LightExitFullScreenIconURL",

		/* Table */
		TableCopyBorderColor: "Cyan600",
		TablePasteBorderColor: "Cyan600",
		TableNewRowBackgroundColor: "Cyan100",

		/* Slicer */
		SlicerMetricsBackgroundColor: "Cyan100",

		/* Chart */
		ChartAreaURL: "ChartAreaCyanURL",
		ChartBarURL: "ChartBarCyanURL",
		ChartColumnURL: "ChartColumnCyanURL",
		ChartDoughnutURL: "ChartDoughnutCyanURL",
		ChartLineURL: "ChartLineCyanURL",
		ChartMsAreaURL: "ChartMsAreaCyanURL",
		ChartMsBarURL: "ChartMsBarCyanURL",
		ChartMsColumnURL: "ChartMsColumnCyanURL",
		ChartMsLineURL: "ChartMsLineCyanURL",
		ChartParetoURL: "ChartParetoCyanURL",
		ChartPieURL: "ChartPieCyanURL",
		ChartStackedAreaURL: "ChartStackedAreaCyanURL",
		ChartStackedBarURL: "ChartStackedBarCyanURL",
		ChartStackedColumnURL: "ChartStackedColumnCyanURL",

		/* Progress bar */
		ProgressBarDeterminateProgressColor: "PrimaryColor",

		HighlightSelected: "Cyan50"
	};
});